module.exports = __webpack_public_path__ + "static/media/Mara Ma.b517f6c1.png";